import { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import Layout from "./components/common/layout";
import Loader from "./components/common/loader";
import RouterRoutes from "./components/core/RouterRoutes.tsx";
import store from "./components/core/store.js";

const App = () => {
  return (
    <Provider store={store}>
      <Layout>
        <Suspense fallback={<Loader />}>
          <RouterRoutes />
        </Suspense>
      </Layout>
    </Provider>
  );
};
export default App;
